import Backend from 'App/Dataman-Backend';

const { apiUrlComponents, apiUrlSuffix, apiUrlComponentsStats, apiComponentPackages, apiComponentCategories } =
  Backend.config;

export const COMPONENTS_PATHS = {
  components: apiUrlComponents,
  suffix: apiUrlSuffix,
  stats: apiUrlComponentsStats,
  packages: apiComponentPackages,
  categories: apiComponentCategories,
};
